import { fetchTemplateForEditor, resetEditor, selectActiveTemplate, selectError, selectIsLoaded, selectIsLoading } from 'modules/manager/store';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'store/hooks';

export interface UseLoadTemplateResult {
  templateId: number | null;
  isLoading: boolean;
  isLoaded: boolean;
  error: string | null;
  activeTemplate: ReturnType<typeof selectActiveTemplate>;
}

export function useLoadTemplate(): UseLoadTemplateResult {
  const dispatch = useAppDispatch();
  const { templateId: templateIdParam } = useParams<{ templateId: string }>();

  const templateId = parseId(templateIdParam);

  const isLoading = useAppSelector(selectIsLoading);
  const isLoaded = useAppSelector(selectIsLoaded);
  const error = useAppSelector(selectError);
  const activeTemplate = useAppSelector(selectActiveTemplate);

  useEffect(() => {
    if (templateId === null) return;
    dispatch(fetchTemplateForEditor({ templateId }));
  }, [dispatch, templateId]);

  useEffect(() => {
    return () => {
      dispatch(resetEditor());
    };
  }, [dispatch]);

  return { templateId, isLoading, isLoaded, error, activeTemplate };
}

function parseId(raw: string | undefined): number | null {
  if (!raw) return null;
  const n = Number(raw);
  return Number.isFinite(n) && n > 0 ? n : null;
}
